<mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>

<div class="container-dashboard" *ngIf="!isLoading">
  <app-alert-message></app-alert-message>
  <header>
    @if (dashboardData.companyName==null) {

      <h1>
        {{ 'dashboard.welcome-back' | translate}}!
      </h1>

    }
    @else(){

      <h1>
        {{ 'dashboard.welcome-back' | translate}}, {{ dashboardData.companyName }}!
      </h1>

    }
    <ng-template #noName>
      <h1>{{ 'dashboard.welcome' | translate}}!</h1>
    </ng-template>
    <p>{{ 'dashboard.description-page' | translate}}</p>
  </header>

  <section class="metrics">
    <div class="metric-card blue">
      <div class="mc-left">
        <h2>{{ 'dashboard.total-score' | translate}}</h2>
        <p class="score">{{ dashboardData.inclusionIndex | number:'1.1-2' }}</p>
        <span>{{ 'dashboard.inclusion-index' | translate}}</span>
      </div>
      <div class="mc-right">
        <mat-icon class="icon-top">show_chart</mat-icon>
      </div>
    </div>

    <div class="metric-card light-blue">
      <div class="mc-left">
        <h2>{{ 'dashboard.level' | translate }}</h2>
        <p class="level">{{ inclusionLevelTranslate() | translate}}</p>
        <span>{{ 'dashboard.corresponding' | translate }}: {{ dashboardData.selfAssessmentReport.letterGrade }}</span>
      </div>
      <div class="mc-right">
        <span>{{ dashboardData.selfAssessmentReport.letterGrade }}</span>
      </div>
    </div>

    <div class="metric-card yellow">
      <div class="mc-left">
        <h2>{{ 'dashboard.total-reviews' | translate }}</h2>
        <p class="reviews">{{ dashboardData.traineesCompletedQuestionnaires }}</p>
        <span>{{ 'dashboard.last' | translate }}: {{dashboardData.lastTraineeSubmissionDate | date:'dd/MM/yyyy'}}</span>
      </div>
      <div class="mc-right">
        <mat-icon class="icon-top">check</mat-icon>
      </div>
    </div>

    <!-- <div class="metric-card">
      <div class="mc-left">
        <h2>Overall Progress</h2>
        <p class="progress">
          {{ getAverageProgress() > 0 ? (ceilTwoDecimals(getAverageProgress()) + '%') : '--' }}
        </p>
        <span>Above average</span>
      </div>
      <div class="mc-right">
        <mat-icon class="icon-top">bar_chart</mat-icon>
      </div>
    </div> -->
  </section>

  <div class="main-content-row">
    <section class="progress-dimensions">
      <h2><mat-icon class="icon-top">bar_chart</mat-icon> {{ 'dashboard.progress-by-dimension' | translate }}</h2>
      <ul>
        <li *ngFor="let dimensionEntry of progressByDimension | keyvalue">
          <div class="label">{{ getDimensionLabelTranslationKey(dimensionEntry.key) | translate }}</div>
          <div class="progress-row">
            <progress [value]="dimensionEntry.value" max="5"></progress>
            <span>{{ ceilTwoDecimals(dimensionEntry.value) }} / 5</span>
          </div>
        </li>
      </ul>
    </section>

      <aside class="quick-actions">
      <h2><mat-icon class="icon-top">bolt</mat-icon> {{ 'dashboard.quick-actions' | translate }}</h2>

      <button class="action-button yellow"
              (click)="fillQuestionnaire()"
              [disabled]="!isQuestionnaireAvailable"
              [matTooltip]="tooltipReasonKey ? (tooltipReasonKey | translate: tooltipReasonParams) : ''"
              matTooltipPosition="below">
        <strong>{{ 'dashboard.fill-self-assessment' | translate }}</strong>
        <p>{{ 'dashboard.fill-self-assessment-description' | translate }}</p>
      </button>

      <a class="action-button outline" [routerLink]="'/available-internships'">
        <strong>{{ 'dashboard.available-internship' | translate }}</strong>
        <p>{{ 'dashboard.available-internship-description' | translate }}</p>
      </a>

      <a class="action-button ghost" [routerLink]="'/internships'">
        <strong>{{ 'dashboard.internships' | translate }}</strong>
        <p>{{ 'dashboard.internships-description' | translate }}</p>
      </a>

      <a class="action-button outline" [routerLink]="'/report-and-results'">
        <strong>{{ 'dashboard.view-report-analysis' | translate }}</strong>
        <p>{{ 'dashboard.view-report-analysis-description' | translate }}</p>
      </a>

      <a class="action-button ghost" [routerLink]="'/training-course'">
        <strong>{{ 'dashboard.training-course' | translate }}</strong>
        <p>{{ 'dashboard.training-course-description' | translate }}</p>
      </a>

    </aside>

  </div>
</div>


